import ABCyaPhaser from '@abcya/abcya_phaser';
import Phaser from 'phaser';
import staticGameData from '../data/GameData';
import FontKeys from '../FontKeys';
import gameData, { MATH_MODE } from '../gameData';
import SoundAssetKeys from '../SoundAssetKeys';
import { playTitleJingle } from '../SoundManager';
import UIAssetKeys from '../UIAssetKeys';
import MarbleDrop from './MarbleDrop';
import RoundSelectScreen from './RoundSelectScreen';

export default class MarbleDropResults extends Phaser.Scene {
  static get KEY() { return 'MarbleDropResults'; }

  constructor() {
    super({ key: MarbleDropResults.KEY });
  }

  init() {
    this.lblCorrect = null;
    this.lblIncorrect = null;
    this.lblScore = null;

    this.btnBack = null;
  }

  create() {
    this.bg = this.add.image(0,0,'dropresultsbackground').setOrigin(0);

    this.lblCorrect = ABCyaPhaser.Text.addText(478, 107, 22, 0xffffff, FontKeys._BPreplay_Bold, staticGameData.dropData.correct.toString(), this, false).setOrigin(0.5, 0);

    this.lblIncorrect = ABCyaPhaser.Text.addText(478, 225, 22, 0xffffff, FontKeys._BPreplay_Bold, staticGameData.dropData.incorrect.toString(), this, false).setOrigin(0.5, 0);

    this.lblScore = ABCyaPhaser.Text.addText(478, 410, 78, 0x2882A5, FontKeys._BPreplay_Bold, staticGameData.dropData.score.toString(), this, false).setOrigin(0.5, 0);

    this.btnBack = ABCyaPhaser.Images.addImage(20, 500, UIAssetKeys._md_assets_BtnBackWithShadow, this).setOrigin(0)
      .setInteractive();
    this.btnBack.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.onBackClick, this);

    ABCyaPhaser.Audio.playOneShot(SoundAssetKeys._SlideWhistleSound, this);
    playTitleJingle(this);
    this.layoutRatio();
  }

  onBackClick () {
    if (gameData.GAME_MODE === MATH_MODE) {
      this.scene.start(RoundSelectScreen.KEY);
    }
    else this.scene.start(MarbleDrop.KEY);
  }

  layoutRatio () {
    this.lblCorrect.x = 520;
    this.lblCorrect.y = 170;

    this.lblIncorrect.x = 520;
    this.lblIncorrect.y = 300;

    this.lblScore.x = 520;
    this.lblScore.y = 500;

    this.btnBack.x = 20;
    this.btnBack.y = this.scale.height - this.btnBack.height - 20;
  }
}